(() => {
  if (window.galixBenefitsCinema) return;
  const clamp = (value, min = 0, max = 1) => Math.min(max, Math.max(min, value));
  const palettes = [[171, 139, 255], [112, 231, 197], [151, 190, 255], [225, 153, 217]];
  const names = ['Galaxia', 'Aurora', 'Luna', 'Nebulosa'];

  function init(section) {
    if (section.galixCinema) return;
    const controller = new AbortController();
    const { signal } = controller;
    const scene = section.querySelector('.galix-benefits__scene');
    const inner = section.querySelector('.galix-benefits__inner');
    const intro = section.querySelector('.galix-section__intro');
    const tabList = section.querySelector('.galix-benefits__tabs');
    const rig = section.querySelector('[data-cinema-rig]');
    const product = section.querySelector('[data-cinema-product]');
    const shadow = section.querySelector('[data-cinema-shadow]');
    const stars = section.querySelector('[data-cinema-stars]');
    const progressBar = section.querySelector('[data-cinema-progress]');
    const label = section.querySelector('[data-cinema-label]');
    const power = section.querySelector('[data-cinema-power-toggle]');
    const hint = section.querySelector('[data-cinema-hint]');
    const hintText = hint?.querySelector('[data-cinema-hint-text]');
    const worlds = [...section.querySelectorAll('[data-cinema-world]')];
    const tabs = [...section.querySelectorAll('[data-benefit-tab]')];
    const copy = section.dataset;
    const worldNames = (copy.txtWorlds || '').split('|').map((name) => name.trim()).filter(Boolean);
    const labels = worldNames.length === names.length ? worldNames : names;
    const preference = matchMedia('(prefers-reduced-motion: reduce)');
    const desktopQuery = matchMedia('(min-width: 990px)');
    const mobilePinQuery = matchMedia('(max-width: 599px)');
    let frame = 0, current = 0, target = 0, activeIndex = -1, scrollStep = 0, visible = false, manual = false, lastTime = 0;
    let powered = section.dataset.cinemaPower !== 'off';
    let sectionTop = 0, sectionHeight = 1, sceneHeight = 1, stickyTop = 0;
    section.galixCinema = controller;
    section.dataset.motion = preference.matches ? 'reduced' : 'scroll';

    function select(index) {
      if (activeIndex === index) return;
      activeIndex = index;
      tabs.forEach((tab, i) => {
        tab.classList.toggle('is-active', i === index);
        tab.classList.toggle('is-past', i < index);
        tab.setAttribute('aria-expanded', String(i === index));
        tab.tabIndex = desktopQuery.matches ? (i === index ? 0 : -1) : 0;
      });
      section.dataset.scrollStep = String(index + 1);
    }

    function paint(progress) {
      const p = clamp(progress);
      const slot = p * 3;
      const lower = Math.floor(slot), upper = Math.min(3, lower + 1);
      const fraction = slot - lower;
      const mix = fraction * fraction * (3 - 2 * fraction);
      const color = palettes[lower].map((v, i) => (v + (palettes[upper][i] - v) * mix).toFixed(2));
      section.style.setProperty('--cinema-light', color.join(' '));
      worlds.forEach((world, index) => {
        world.style.opacity = (index === lower ? 1 - mix : index === upper ? mix : 0).toFixed(4);
      });
      const desktop = desktopQuery.matches;
      if (!preference.matches) {
        // Desktop stays anchored. On mobile the projector glides into view as the story advances.
        rig.style.transform = '';
        if (mobilePinQuery.matches) {
          const wave = Math.sin(p * Math.PI * 4);
          const x = 14 - 34 * p + 4 * wave;
          const y = 20 - 30 * p - 8 * wave;
          const angle = 3 - 6 * p + 1.5 * wave;
          product.style.transform = `translate3d(${x.toFixed(2)}px,${y.toFixed(2)}px,0) rotate(${angle.toFixed(2)}deg)`;
        } else product.style.transform = '';
        shadow.style.transform = '';
        stars.style.transform = `translate3d(${(-14 * p).toFixed(2)}px,${(18 * p).toFixed(2)}px,0)`;
      } else {
        rig.style.transform = ''; product.style.transform = ''; stars.style.transform = ''; shadow.style.transform = ''; shadow.style.opacity = '';
      }
      const name = powered ? labels[Math.min(3, Math.round(slot))] : (copy.txtOff || 'Proyección apagada');
      if (label.textContent !== name) label.textContent = name;
      progressBar.style.transform = `scaleX(${(.08 + p * .92).toFixed(4)})`;
      section.dataset.motionProgress = p.toFixed(4);
      if (!manual && !preference.matches) {
        // On desktop, reveal the last card close to the exit so the next scroll moves on.
        const steps = desktop ? tabs.length - .5 : mobilePinQuery.matches ? tabs.length - .35 : tabs.length + 1;
        select(isPinned() ? Math.min(tabs.length - 1, Math.floor(p * steps)) : scrollStep);
      }
    }

    function measure() {
      // Measure intrinsic content, not the centered wrapper's viewport-sized height.
      const innerStyle = getComputedStyle(inner);
      const requiredHeight = intro.offsetHeight + tabList.offsetHeight
        + (parseFloat(getComputedStyle(tabList).marginTop) || 0)
        + (parseFloat(innerStyle.paddingTop) || 0)
        + (parseFloat(innerStyle.paddingBottom) || 0);
      const stickyInset = parseFloat(getComputedStyle(scene).top) || 0;
      const layout = desktopQuery.matches && requiredHeight > innerHeight - stickyInset ? 'flow' : 'pinned';
      if (section.dataset.cinemaLayout !== layout) section.dataset.cinemaLayout = layout;
      sectionTop = section.getBoundingClientRect().top + scrollY;
      sectionHeight = section.offsetHeight;
      sceneHeight = scene.offsetHeight;
      stickyTop = parseFloat(getComputedStyle(scene).top) || 0;
    }
    function isPinned() {
      return (desktopQuery.matches || mobilePinQuery.matches) && section.dataset.cinemaLayout !== 'flow';
    }
    function scrollProgress() {
      if (isPinned()) return clamp((scrollY + stickyTop - sectionTop) / Math.max(1, sectionHeight - sceneHeight));
      scrollStep = mobileStep();
      return scrollStep / Math.max(1, tabs.length - 1);
    }
    function mobileStep() {
      const readingLine = innerHeight * .28;
      let index = 0;
      tabs.forEach((tab, i) => {
        if (tab.getBoundingClientRect().top <= readingLine) index = i;
      });
      return index;
    }
    function tick(time) {
      frame = 0;
      if (signal.aborted) return;
      const dt = Math.min(64, time - (lastTime || time - 16)); lastTime = time;
      current += (target - current) * (1 - Math.exp(-dt / (manual ? 210 : 135)));
      if (Math.abs(target - current) < .00015) current = target;
      paint(current);
      if (visible && current !== target && !preference.matches) frame = requestAnimationFrame(tick);
    }
    function schedule() { if (!frame && !signal.aborted) { lastTime = 0; frame = requestAnimationFrame(tick); } }
    function onScroll() {
      if (!visible || preference.matches || manual) return;
      target = scrollProgress(); schedule();
    }
    // Layout anchoring and focus scrolling must not cancel a chosen benefit.
    // Resume the scroll choreography only after a deliberate scrolling gesture.
    function resumeScroll() { manual = false; }
    function resize() { measure(); if (!manual && !preference.matches) target = scrollProgress(); schedule(); }
    function choose(index, focus = false) {
      manual = true; select(index); target = index / Math.max(1, tabs.length - 1);
      if (focus) tabs[index].focus({ preventScroll: true });
      if (preference.matches) { current = target; paint(current); } else schedule();
    }
    function setPower(on) {
      powered = on;
      section.dataset.cinemaPower = on ? 'on' : 'off';
      power.setAttribute('aria-pressed', String(on));
      power.setAttribute('aria-label', on ? (copy.txtPowerOff || 'Apagar proyector') : (copy.txtPowerOn || 'Encender proyector'));
      if (hintText) hintText.textContent = on ? (copy.txtHintOff || 'Pulsa el proyector para apagar la luz') : (copy.txtHintOn || 'Pulsa de nuevo para encender la luz');
      paint(current);
    }
    if (power) {
      power.disabled = false;
      power.addEventListener('click', () => setPower(!powered), { signal });
      product.addEventListener('click', event => {
        if (event.target.closest('[data-cinema-power-toggle]')) return;
        setPower(!powered);
      }, { signal });
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => choose(index), { signal });
      tab.addEventListener('keydown', event => {
        let next;
        if (['ArrowDown', 'ArrowRight'].includes(event.key)) next = (index + 1) % tabs.length;
        else if (['ArrowUp', 'ArrowLeft'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else return;
        event.preventDefault(); choose(next, true);
      }, { signal });
    });
    const observer = new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      section.dataset.cinemaVisible = String(visible);
      if (visible) {
        measure();
        if (!manual && !preference.matches) {
          target = scrollProgress();
          current = target;
          paint(current);
        } else schedule();
      }
      else { cancelAnimationFrame(frame); frame = 0; manual = false; }
    });
    const resizeObserver = new ResizeObserver(resize);
    observer.observe(section); resizeObserver.observe(section); resizeObserver.observe(inner);
    window.addEventListener('scroll', onScroll, { passive: true, signal });
    window.addEventListener('wheel', resumeScroll, { passive: true, signal });
    window.addEventListener('touchmove', resumeScroll, { passive: true, signal });
    window.addEventListener('pointerdown', event => {
      if (!event.target.closest?.('[data-benefit-tab], [data-cinema-product]')) resumeScroll();
    }, { passive: true, signal });
    window.addEventListener('keydown', event => {
      if (!event.target.closest?.('[data-benefit-tab]') && ['ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End', ' '].includes(event.key)) resumeScroll();
    }, { signal });
    window.addEventListener('resize', resize, { passive: true, signal });
    preference.addEventListener('change', () => {
      cancelAnimationFrame(frame); frame = 0;
      section.dataset.motion = preference.matches ? 'reduced' : 'scroll';
      manual = false; measure(); target = preference.matches ? 0 : scrollProgress(); current = target;
      select(0); paint(current);
    }, { signal });
    signal.addEventListener('abort', () => {
      cancelAnimationFrame(frame); observer.disconnect(); resizeObserver.disconnect();
      if (power) power.disabled = true;
      delete section.galixCinema;
    }, { once: true });
    select(0); measure(); paint(0);
    document.fonts?.ready.then(() => { if (!signal.aborted) resize(); });
  }
  function mount(root = document) {
    if (root.matches?.('[data-benefits-cinematic]')) init(root);
    root.querySelectorAll('[data-benefits-cinematic]').forEach(init);
  }
  window.galixBenefitsCinema = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.matches?.('[data-benefits-cinematic]')) event.target.galixCinema?.abort();
    event.target.querySelectorAll('[data-benefits-cinematic]').forEach(section => section.galixCinema?.abort());
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(), { once: true });
  else mount();
})();
